export var createQueryKey = function (key) { return ({
    all: [key],
    byId: function (id) { return [key, id]; },
    byParams: function (params) { return [key, params]; },
    byIdParams: function (id, params) { return [key, id, params]; },
}); };
